import { AxiosResponse } from 'axios'
import {
  Entity,
  IEvidenciaMovMensal,
  IResponseGetContratosId,
  RequestEvidenciaMovMensal,
  RequestGetPesquisaAnalista,
  RequestSalvarMovimentacao,
  RequestUploadEfetivos,
  ResponseCompetenciaAnterior,
  ResponseEnviarVisualIndividual,
  ResponseGetContratoMovMensal,
  ResponseGetMovimentacao,
  ResponseGetParametrizacaoEfeitvo,
  ResponseGetPesquisaAnalista,
  ResponseGetPesquisaMovimentacao,
  ResponseUploadEfetivos
} from 'pages/Supplier/MovMensal/types'
import { RequestCDU, RequestREAD } from 'services/Instances'

export function MovimentacaoMensalServices() {
  const getPesquisaMovimentacao = async (
    params: IGetPesquisaMovimentacaoParams
  ): Promise<AxiosResponse<ResponseGetPesquisaMovimentacao>> =>
    await RequestREAD.get('EfetivoPesquisa', { params })

  const getPesquisaMovAnalista = async (
    objRequest: RequestGetPesquisaAnalista
  ): Promise<AxiosResponse<ResponseGetPesquisaAnalista>> =>
    await RequestREAD.get('EfetivoPesquisa/ForNGT', {
      params: objRequest
    })

  const getMovimentacao = async (
    idContrato: number,
    anoMes: string,
    isSemMobilizacao: Boolean = false
  ): Promise<AxiosResponse<ResponseGetMovimentacao>> =>
    await RequestREAD.get(
      `MovimentacaoMensal/${idContrato}/${anoMes}/0?isSemMobilizacao=${isSemMobilizacao}`
    )

  const getMovimentacaoCompartilhada = async (
    idContrato: number,
    anoMes: string,
    contratoId: number
  ): Promise<AxiosResponse<ResponseGetMovimentacao>> =>
    await RequestREAD.get(
      `MovimentacaoMensal/${idContrato}/${anoMes}/${contratoId}?isCompartilhado=true`
    )

  const getCompetenciaAnterior = async (
    idContrato: number,
    mesAno: string,
    isSemMobilizacao: Boolean = false,
    enviarMovInvalida: Boolean = false
  ): Promise<AxiosResponse<ResponseCompetenciaAnterior>> =>
    await RequestREAD.get('MovimentacaoMensal/CompAnterior', {
      params: {
        idContrato: idContrato,
        mesAno: mesAno,
        isSemMobilizacao: isSemMobilizacao,
        enviarMovInvalida: enviarMovInvalida
      }
    })

  const enviarVisaoIndividual = async (
    request: Entity[]
  ): Promise<AxiosResponse<ResponseEnviarVisualIndividual>> =>
    await RequestREAD.post(`MovimentacaoMensal`, request)

  const downloadVisaoIndividual = async (
    request: Entity[]
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(`MovimentacaoMensal/MovEfetivoExcel`, request)

  const uploadEfetivos = async (
    request: RequestUploadEfetivos
  ): Promise<AxiosResponse<ResponseUploadEfetivos>> =>
    await RequestCDU.post('MovimentacaoEfetivo/CreateFileXls', request)

  const salvarMovimentacao = async (
    request: RequestSalvarMovimentacao
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`MovimentacaoMensal/MovAndMovEfetivo`, request)

  const updateMovimentacao = async (
    request: RequestSalvarMovimentacao
  ): Promise<AxiosResponse> =>
    await RequestCDU.put(`MovimentacaoMensal/MovAndMovEfetivo`, request)

  const getDadosParametrizacao = async (): Promise<
    AxiosResponse<ResponseGetParametrizacaoEfeitvo[]>
  > => await RequestREAD.get('ParametrizacaoEfetivo')

  const getContratoMovimentacaoMensal = async (
    idContrato: number
  ): Promise<AxiosResponse<ResponseGetContratoMovMensal>> =>
    await RequestREAD.get(`Contrato/GetById/${idContrato}`)

  const getEvidenciaMovMensal = async (
    idMovimentacao: number | string
  ): Promise<AxiosResponse<IEvidenciaMovMensal[]>> =>
    await RequestREAD.get('AnexarDocEvidencia/' + idMovimentacao + '/3')

  const anexarEvidenciaMensal = async (
    objRequest: RequestEvidenciaMovMensal
  ): Promise<AxiosResponse> =>
    await RequestCDU.post('AnexarDocEvidenciaMovimentacao', objRequest)

  const deleteEvidenciaMensal = async (
    idAnexarDoc: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.delete(
      'AnexarDocEvidenciaMovimentacao/Delete/' + idAnexarDoc
    )

  const getContratosId = async (
    anoMes: string,
    cdContrato: string,
    fornecedorId: number,
    cdContratoMovimentacao: string
  ): Promise<AxiosResponse<IResponseGetContratosId>> =>
    await RequestREAD.get('/MovimentacaoMensal/Autocomplete', {
      params: {
        anoMes: anoMes,
        cdContrato: cdContrato,
        fornecedorId: fornecedorId,
        cdContratoMovimentacao: cdContratoMovimentacao
      }
    })

  const createMov = async (
    request_body: MovCreateAndUpdateBody
  ): Promise<AxiosResponse<MovResponse>> =>
    await RequestCDU.post('MovimentacaoMensal/CreateMov', request_body)

  const updateMov = async (
    request_body: MovCreateAndUpdateBody
  ): Promise<AxiosResponse<MovResponse>> =>
    await RequestCDU.put('MovimentacaoMensal/UpdateMov', request_body)

  const verificaDuplicados = async (
    contratoId: number,
    nuAnoMesCompetencia: string
  ): Promise<AxiosResponse<verificaDuplicados>> =>
    await RequestREAD.get(`Movimentacao/${contratoId}/${nuAnoMesCompetencia}`);

  return {
    anexarEvidenciaMensal,
    createMov,
    getMovimentacaoCompartilhada,
    deleteEvidenciaMensal,
    downloadVisaoIndividual,
    enviarVisaoIndividual,
    getCompetenciaAnterior,
    getContratoMovimentacaoMensal,
    getContratosId,
    getDadosParametrizacao,
    getEvidenciaMovMensal,
    getMovimentacao,
    getPesquisaMovAnalista,
    getPesquisaMovimentacao,
    salvarMovimentacao,
    updateMov,
    updateMovimentacao,
    uploadEfetivos,
    verificaDuplicados
  }
}

export interface IGetPesquisaMovimentacaoParams {
  idUsuario: number
  CdContrato?: string
  CompetenciaInicio?: Date
  CompetenciaFim?: Date
  NomeFornecedor?: string
  isContraparte?: boolean
}

export interface Movimentacao {
  flSalvarVerificar: boolean
  idMovimentacao: number
  nuAnoMesCompetencia: string
  flStatusMobilizacao: string
  contratoId: number
  contratoCompartilhadoId: number
  qtAtivo: number
  qtDemitido: number
  qtAcesso: number
  qtTransferido: number
  qtAfastado: number
  qtCompartilhado: number
  qtTotalEfetivo: number
  qtClt: number
  qtSocio: number
  qtCooperado: number
  qtEstrangeiro: number
  qtEstagiario: number
  qtAutonomo: number
  qtMei: number
  qtNeAtual: number
  peNePercVarAtual: number
  vlNeVariacaoAtual: number
  txNeJustificativa: string
  qtHeQtd: number
  qtHeNormal: number
  peHeVariacao: number
  txHeJustificativa: string
  vlSalBase: number
  txSalBaseJustificativa: string
  vlFolhaPagto: number
  vlHoraExtras: number
  cdContraparte: string
  flValidContraparte: boolean
  dtValidContraparte: string | Date
  cdAnalista: string
  flValidAnalista: boolean
  dtValidAnalista: string | Date
  peValVariacao: number
  flMovValida: boolean
  usuarioId: number
}

export interface MovEfetivo {
  idMovEfetivo: number
  flDelete?: boolean
  movimentacaoId: number
  fornecedorId: number
  contratoId: string
  cdNacionalidade: string
  cdCpfPassaporte: string
  cdGenero: string
  nmColaborador: string
  cdStatus: string
  dtAdmissao?: Date
  dtDemissao?: Date
  cdTipoEfetivo: string
  txFuncao: string
  nuAnoMesCompetencia?: string
  cdCategoria: string
  vlHoraExtras: number
  vlSalBase: number
}

export interface MovCreateAndUpdateBody {
  movimentacao: Movimentacao
  movEfetivos: MovEfetivo[]
}


export interface Value {
  $id?: string
  flError: boolean
  cdCpfPassaporte: string
  name: string
  message: string
  mensagem?: string
}

export interface ErrorList {
  $id: string
  $values: Value[]
}

export interface Value2 {
  $id: string
  idMovEfetivo: number
  movimentacaoId: number
  fornecedorId: number
  contratoId: string
  cdContrato: any
  cdNacionalidade: string
  cdCpfPassaporte: string
  cdGenero: string
  nmColaborador: string
  cdStatus: string
  dtAdmissao: Date
  dtDemissao?: any
  cdTipoEfetivo: string
  txFuncao: string
  nuMesAnoCompetencia: any
  cdCategoria: string
  vlHoraExtras: number
  vlSalBase: number
  flDelete: boolean
}

export interface CompAtual {
  $id: string
  $values: Value2[]
}

export interface CamposCalculados {
  flStatusMoblizacao: string
  $id: string
  qtAtivo: number
  qtDemitido: number
  qtAcesso: number
  qtTransferido: number
  qtAfastado: number
  qtCompartilhado: number
  qtTotalEfetivo: number
  qtClt: number
  qtSocio: number
  qtCooperado: number
  qtEstrangeiro: number
  qtEstagiario: number
  qtAutonomo: number
  qtMei: number
  qtNeAnterior: number
  qtNeAtual: number
  vlSalBaseAnterior: number
  idMovimentacao: number
  vlSalBase: number
  txSalBaseJustificativa: string
  flPagtoAnterior: number
  vlHoraExtras: number
}

export interface Valor {
  $id: string
  idMovimentacao: number
  errorList: ErrorList
  compAtual: CompAtual
  mov: CamposCalculados
  sucesso: boolean
  mensagem?: any
  detalhe?: any
  tipo?: any
}

export interface MovResponse {
  $id: string
  valor: Valor
  sucesso: boolean
  mensagem: string
  detalhe?: any
  tipo?: any
}

export interface verificaDuplicados {
  entity: number;
  mensagem: string;
  sucesso: boolean;
}
